import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import type { IWeather } from "../../models/storeModels/IWeather";

const initialState: IWeather = {
    weatherData: null
}

export const weatherSlice = createSlice({
    name: 'weather',
    initialState,
    reducers: {
        changeWeatherData(state, action: PayloadAction<any>) {
            state.weatherData = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const { changeWeatherData } = weatherSlice.actions
export const weatherReducer = weatherSlice.reducer;
